
const FollowersByUserUuid_query = `query($userUuid: String!){
  followersByUseruuid(userUuid: $userUuid){
    followId
    uuid 
    userId
    {
      username
      userUuid
      id
      firstName
      lastName
      avatarFileName
      
      
    }
    followerId
    {
      username
      userUuid
      id
      firstName
      lastName
      avatarFileName
      isLoggedInUserFollowing
    }
    isFollowing
  }   
}`;

const FollowingsByUserUuid_query = `query($userUuid: String!){
  followingsByUseruuid(userUuid: $userUuid){
    followId
    uuid 
    userId
    {
      username
      userUuid
      id
      firstName
      lastName
      avatarFileName
      isLoggedInUserFollowing
      
    }
    followerId
    {
      username
      userUuid
      id
      firstName
      lastName
      avatarFileName
    }
    isFollowing
  }   
}`;

const followingStatusByUseruuidFollowerUuid_query = 
`query($userUuid: String!, $followerUuid: String!){
  followingStatusByUseruuidFolloweruuid(
    userUuid: $userUuid
    followerUuid: $followerUuid){
      response
    }   
}`;

const CreateFollow_mutate = `
    mutation createFollow(
      $userUuid: String!,      
      
      ) {
      createFollow(
        userUuid: $userUuid,
        
        ) {
        
        follow
        {
          userId
          {
            username
            followerNo
            followingNo
            
          }
          followerId
          {
            username
            followingNo
            followerNo
          }
        }
      }
    }
`;

const DeleteFollow_mutate = `
    mutation deleteFollow(
      $userUuid: String!    
      
      ) {
      deleteFollow(
        userUuid: $userUuid        
        ) {
        
        response
      }
    }
`;

module.exports = {
  FOLLOWERS_BY_USER_UUID: FollowersByUserUuid_query,
  FOLLOWINGS_BY_USER_UUID: FollowingsByUserUuid_query,
  FOLLOWING_STATUS_BY_USER_FOLLOWER_UUID: 
    followingStatusByUseruuidFollowerUuid_query,
  CREATE_FOLLOW_MUTATION: CreateFollow_mutate,
  DELETE_FOLLOW_MUTATION: DeleteFollow_mutate
}